import React, { useState, useEffect } from 'react'
import { serbaUsahaService } from '../../services/serbaUsahaService'

function BarangList() {
  const [barang, setBarang] = useState([])
  const [loading, setLoading] = useState(true)
  const [search, setSearch] = useState('')
  const [kategori, setKategori] = useState('')
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [showModal, setShowModal] = useState(false)
  const [editKode, setEditKode] = useState(null)
  const [form, setForm] = useState({ NamaBarang: '', Kategori: 'Sembako', HargaTunai: '', HargaKredit: '', Stok: 0, Satuan: 'pcs' })

  const fetchData = async () => {
    try {
      setLoading(true)
      const res = await serbaUsahaService.getBarang({ search, kategori: kategori || undefined, page, limit: 20 })
      setBarang(res.data.data || [])
      const meta = res.data.meta
      setTotalPages(meta?.totalPages || 1)
    } catch (err) { console.error(err) }
    finally { setLoading(false) }
  }

  useEffect(() => { fetchData() }, [page, search, kategori])

  const formatCurrency = (val) => new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(val || 0)

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      if (editKode) {
        await serbaUsahaService.updateBarang(editKode, form)
      } else {
        await serbaUsahaService.createBarang(form)
      }
      setShowModal(false); setEditKode(null)
      setForm({ NamaBarang: '', Kategori: 'Sembako', HargaTunai: '', HargaKredit: '', Stok: 0, Satuan: 'pcs' })
      fetchData()
    } catch (err) { alert('Gagal menyimpan barang') }
  }

  const handleEdit = (item) => {
    setForm({ NamaBarang: item.NamaBarang, Kategori: item.Kategori, HargaTunai: item.HargaTunai, HargaKredit: item.HargaKredit, Stok: item.Stok, Satuan: item.Satuan })
    setEditKode(item.KodeBarang)
    setShowModal(true)
  }

  const handleDelete = async (kode) => {
    if (!confirm('Nonaktifkan barang ini?')) return
    await serbaUsahaService.deleteBarang(kode)
    fetchData()
  }

  return (
    <div className="card">
      <div className="card-header"><h3 className="card-title">Data Barang</h3>
        <div className="card-tools">
          <button className="btn btn-primary btn-sm" onClick={() => { setEditKode(null); setForm({ NamaBarang: '', Kategori: 'Sembako', HargaTunai: '', HargaKredit: '', Stok: 0, Satuan: 'pcs' }); setShowModal(true) }}>
            + Tambah Barang
          </button>
        </div>
      </div>
      <div className="card-body">
        <div className="row mb-3">
          <div className="col-md-4">
            <input className="form-control" placeholder="Cari barang..." value={search} onChange={e => { setSearch(e.target.value); setPage(1) }} />
          </div>
          <div className="col-md-3">
            <select className="form-control" value={kategori} onChange={e => { setKategori(e.target.value); setPage(1) }}>
              <option value="">Semua Kategori</option>
              <option value="Sembako">Sembako</option>
              <option value="AlatTulis">Alat Tulis</option>
              <option value="Elektronik">Elektronik</option>
              <option value="Lainnya">Lainnya</option>
            </select>
          </div>
        </div>
        {loading ? <div className="text-center py-3"><i className="fas fa-spinner fa-spin fa-2x"></i></div> : (
          <table className="table table-bordered table-hover">
            <thead><tr>
              <th>Kode</th><th>Nama Barang</th><th>Kategori</th><th>Harga Tunai</th><th>Harga Kredit</th><th>Stok</th><th>Satuan</th><th>Status</th><th>Aksi</th>
            </tr></thead>
            <tbody>
              {barang.length === 0 ? <tr><td colSpan="9" className="text-center">Tidak ada data</td></tr> :
                barang.map((b, i) => (
                  <tr key={i}>
                    <td>{b.KodeBarang}</td><td>{b.NamaBarang}</td><td>{b.Kategori}</td>
                    <td className="text-right">{formatCurrency(b.HargaTunai)}</td>
                    <td className="text-right">{formatCurrency(b.HargaKredit)}</td>
                    <td className="text-center">{b.Stok}</td>
                    <td>{b.Satuan}</td>
                    <td>{b.IsActive ? <span className="badge badge-success">Aktif</span> : <span className="badge badge-danger">Nonaktif</span>}</td>
                    <td>
                      <button className="btn btn-sm btn-warning mr-1" onClick={() => handleEdit(b)}><i className="fas fa-edit"></i></button>
                      {b.IsActive && <button className="btn btn-sm btn-danger" onClick={() => handleDelete(b.KodeBarang)}><i className="fas fa-trash"></i></button>}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        )}
        {totalPages > 1 && (
          <div className="d-flex justify-content-center mt-3">
            {Array.from({ length: totalPages }, (_, i) => (
              <button key={i} className={`btn btn-sm ${page === i + 1 ? 'btn-primary' : 'btn-default'} mx-1`} onClick={() => setPage(i + 1)}>{i + 1}</button>
            ))}
          </div>
        )}
      </div>

      {showModal && (
        <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <form onSubmit={handleSubmit}>
                <div className="modal-header">
                  <h5 className="modal-title">{editKode ? 'Edit Barang' : 'Tambah Barang'}</h5>
                  <button type="button" className="close" onClick={() => setShowModal(false)}>&times;</button>
                </div>
                <div className="modal-body">
                  <div className="form-group">
                    <label>Nama Barang</label>
                    <input className="form-control" value={form.NamaBarang} onChange={e => setForm({...form, NamaBarang: e.target.value})} required />
                  </div>
                  <div className="form-group">
                    <label>Kategori</label>
                    <select className="form-control" value={form.Kategori} onChange={e => setForm({...form, Kategori: e.target.value})}>
                      <option value="Sembako">Sembako</option>
                      <option value="AlatTulis">Alat Tulis</option>
                      <option value="Elektronik">Elektronik</option>
                      <option value="Lainnya">Lainnya</option>
                    </select>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Harga Tunai (Rp)</label>
                        <input type="number" className="form-control" value={form.HargaTunai} onChange={e => setForm({...form, HargaTunai: e.target.value})} required />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Harga Kredit (Rp)</label>
                        <input type="number" className="form-control" value={form.HargaKredit} onChange={e => setForm({...form, HargaKredit: e.target.value})} required />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Stok Awal</label>
                        <input type="number" className="form-control" value={form.Stok} onChange={e => setForm({...form, Stok: e.target.value})} />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Satuan</label>
                        <select className="form-control" value={form.Satuan} onChange={e => setForm({...form, Satuan: e.target.value})}>
                          <option value="pcs">pcs</option>
                          <option value="kg">kg</option>
                          <option value="liter">liter</option>
                          <option value="pack">pack</option>
                          <option value="lusin">lusin</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Batal</button>
                  <button type="submit" className="btn btn-primary">Simpan</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
export default BarangList
